<div class="servers-summary">
  <div *ngIf="!selection" class="arm-summary">0 Items selected</div>
  <div *ngIf="selection?.length === 1 || selection" class="arm-summary">
    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Name:</span>
      <span [title]="selection.name" class="arm-summary-value" fxFlex>{{selection.name}}</span>
    </div>

    <div [ngSwitch]="selection.type" class="arm-summary-item upm-type" fxLayout="row">
      <ng-container *ngSwitchCase="'LDAP'">
        <span class="arm-summary-name" fxFlex="45">Type:</span>
        <span [title]="selection.name" class="servers-type-summary-value" matTooltip="LDAP Server"><i
          class="fa fa-group servers-status"></i></span><span style="padding-left: 5px;">LDAP Server</span>
      </ng-container>
      <ng-container *ngSwitchCase="'AZURE'">
        <span class="arm-summary-name" fxFlex="45">Type:</span>
        <span [title]="selection.name" class="servers-type-summary-value"
              matTooltip="Azure Active Directory"> <i class="fa fa-windows servers-status"></i></span><span style="padding-left: 5px;">Azure Active Directory</span>
      </ng-container>
      <ng-container *ngSwitchCase="'UMP'">
        <span class="arm-summary-name" fxFlex="45" >Type:</span>
        <div>
          <span [title]="selection.name" class="servers-type-summary-value" matTooltip="UMP">
            <img src="assets/images/general/ump_icon.svg" class="ump-svg" alt="UMP"/>
          </span>
          <span style="padding-left: 5px;">UMP
          </span>
        </div>
      </ng-container>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Status:</span>
      <span [title]="selection.status" class="arm-summary-value" fxFlex>
        <i class="fa fa-check-circle servers-status available" *ngIf="selection.status === 'available'"></i>
        <i class="fa fa-exclamation-circle servers-status unavailable" *ngIf="selection.status !== 'available'"></i>
      </span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">{{selection.type === 'LDAP' || selection.type === 'UMP' ? 'Host' : 'Tenant Id'}}:</span>
      <span [title]="selection.host" class="arm-summary-value" fxFlex>{{selection.host}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row" *ngIf="selection.type === 'LDAP'">
      <span class="arm-summary-name" fxFlex="45">Port:</span>
      <span [title]="selection.port" class="arm-summary-value" fxFlex>{{selection.port}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Number of users:</span>
      <span [title]="selection.numOfUsers" class="arm-summary-value" fxFlex>{{selection.numOfUsers}}</span>
    </div>

    <ng-container *ngIf="selection.type === 'LDAP'">
      <div class="arm-summary-item" fxLayout="row">
        <span class="arm-summary-name" fxFlex="45">SSL Enabled:</span>
        <span [title]="selection.sslEnabled" class="arm-summary-value" fxFlex>{{selection.sslEnabled}}</span>
      </div>
      <div class="arm-summary-item" fxLayout="row">
        <span class="arm-summary-name" fxFlex="45">Certificate:</span>
        <span *ngIf="selection.sslEnabled" [title]="selection.parsedCertificate" class="arm-summary-value view-certificate" fxFlex (click)="openCertificateView()">view certificate</span>
      </div>
    </ng-container>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">{{selection.type === 'LDAP' ? 'DN' : selection.type === 'UMP' ? 'User' : 'Client Id'}}:</span>
      <span [title]="selection.dn" class="arm-summary-value" fxFlex>{{selection.dn}}</span>
    </div>

    <ng-container *ngIf="selection.type === 'LDAP' || selection.type === 'UMP'">
      <div class="arm-summary-item" fxLayout="row" *ngIf="selection.type !== 'UMP'">
        <span class="arm-summary-name" fxFlex="45">Base Object:</span>
        <span [title]="selection.baseObject" class="arm-summary-value" fxFlex>{{selection.baseObject}}</span>
      </div>
      <div class="arm-summary-item" fxLayout="row" *ngIf="selection.type !== 'UMP'">
        <span class="arm-summary-name" fxFlex="45">Search Filter:</span>
        <div class="servers-certificate-container">
          <span [title]="selection.searchFilter" class="arm-summary-value-long" fxFlex>{{selection.searchFilter}}</span>
        </div>
      </div>

      <div class="arm-summary-item" fxLayout="row">
        <span class="arm-summary-name" fxFlex="45">Sync every:</span>
        <span class="arm-summary-value" fxFlex>{{selection.syncIntervalMinutes}} minute{{selection.syncIntervalMinutes !== 1 ? 's' : ''}}</span>
      </div>

    </ng-container>

    <div class="arm-summary-item" fxLayout="row" *ngIf="selection.type !== 'UMP'">
      <span class="arm-summary-name" fxFlex="45">Full Sync at:</span>
      <span class="arm-summary-value" fxFlex>{{selection.fullSyncHour | LeadingZerosPipe : 2}}:{{selection.fullSyncMinute | LeadingZerosPipe : 2}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Last successful full sync:</span>
      <span class="arm-summary-value" fxFlex>{{selection.lastFullSyncTimestamp | date : 'MMM d, y HH:mm:ss'}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row" *ngIf="selection.type !== 'UMP'">
      <span class="arm-summary-name" fxFlex="45">Page size:</span>
      <span [title]="selection.pageSize" class="arm-summary-value" fxFlex>{{selection.pageSize}}</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Sync Timeout:</span>
      <span class="arm-summary-value" fxFlex>{{selection.timeout}} minutes</span>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Query Timeout:</span>
      <span class="arm-summary-value" fxFlex>{{selection.readTimeout}} seconds</span>
    </div>

    <div class="arm-summary-item" fxLayout="row" *ngIf="selection.type !== 'UMP'">
      <span class="arm-summary-name" fxFlex="45">Mappings:</span>
    </div>

    <div class="summary-mappings" *ngFor="let mapping of selection.dicAttrMapping" >
      <div class="summary-mappings-details">
        <span class="servers-details-mapping-from" fxFlex="45">{{mapping.aDAttrName}}</span>
        <span class="servers-details-mapping-arrow"><i class="fa fa-long-arrow-right"></i></span>
        <span class="servers-details-mapping-to" fxFlex>{{mapping.dicAttrName}}</span>
      </div>
    </div>

    <div class="arm-summary-item" fxLayout="row">
      <span class="arm-summary-name" fxFlex="45">Normalization:</span>
    </div>

    <div class="summary-mappings" *ngFor="let mapping of selection.dicAttrMapping" >
      <div *ngIf="mapping.normalizationGroupId">
        <div class="summary-mappings-details">
          <span class="servers-details-mapping-from" [title]="mapping.aDAttrName">{{mapping.aDAttrName}}</span>
          <span class="servers-details-mapping-arrow"><i class="fa fa-long-arrow-right"></i></span>
          <span class="servers-details-mapping-to"
                [title]="getNormalizationGroupName(mapping.normalizationGroupId)">
                        {{getNormalizationGroupName(mapping.normalizationGroupId)}}
                    </span>
        </div>
      </div>
    </div>

  </div>
</div>
